import styled from "styled-components";
import { Input, Label } from "../Form";

const ChangePhoneNumberLabel = styled(Label)``;

const ChangePhoneNumberInput = styled(Input)``;

export { ChangePhoneNumberLabel, ChangePhoneNumberInput };
